var map = {
	"./LogoDashboard-1.svg": "b9d6",
	"./LogoDashboard-10.svg": "1b4c",
	"./LogoDashboard-11.svg": "8d77",
	"./LogoDashboard-12.svg": "cac3",
	"./LogoDashboard-13.svg": "18d0",
	"./LogoDashboard-14.svg": "449e",
	"./LogoDashboard-15.svg": "0607",
	"./LogoDashboard-16.svg": "c894",
	"./LogoDashboard-17.svg": "3ca9",
	"./LogoDashboard-18.svg": "df56",
	"./LogoDashboard-19.svg": "e3bc",
	"./LogoDashboard-2.svg": "751f",
	"./LogoDashboard-20.svg": "0ede",
	"./LogoDashboard-21.svg": "3f94",
	"./LogoDashboard-22.svg": "c30c",
	"./LogoDashboard-23.svg": "0de5",
	"./LogoDashboard-24.svg": "c739",
	"./LogoDashboard-25.svg": "e15c",
	"./LogoDashboard-26.svg": "6260",
	"./LogoDashboard-27.svg": "e62e",
	"./LogoDashboard-28.svg": "42d0",
	"./LogoDashboard-29.svg": "a261",
	"./LogoDashboard-3.svg": "7217",
	"./LogoDashboard-30.svg": "1efa",
	"./LogoDashboard-31.svg": "b8c6",
	"./LogoDashboard-32.svg": "c071",
	"./LogoDashboard-33.svg": "1746",
	"./LogoDashboard-34.svg": "9d22",
	"./LogoDashboard-35.svg": "dde8",
	"./LogoDashboard-4.svg": "1ad8",
	"./LogoDashboard-5.svg": "c48b",
	"./LogoDashboard-6.svg": "93f3",
	"./LogoDashboard-7.svg": "0d9b",
	"./LogoDashboard-8.svg": "b22b",
	"./LogoDashboard-9.svg": "9ec3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "527a";